import { createSelector } from '@reduxjs/toolkit';
import { UserGraphicsQualityPresetTypes } from '@wg/web2clientapi/browser/getClientSettings';

import type { RootState } from '~/store';

export const currentAccountSelector = (state: RootState) => state.currentAccount;
export const isClientGraphicsLowSelector = (state: RootState) =>
  state.currentAccount.clientSettings?.preset === UserGraphicsQualityPresetTypes.LOW;

const clanItemsSelector = (state: RootState) => state.clans.items;

export const clanItemSelector = (clanId: number) =>
  createSelector(clanItemsSelector, (clanItems) => {
    return clanItems[clanId] || null;
  });

export const currentAccountClanIdSelector = createSelector(currentAccountSelector, (account) => account.clanId);

export const getCurrentClan = createSelector(
  clanItemsSelector,
  currentAccountClanIdSelector,
  (clanItems, currentAccountClanId) => {
    if (!currentAccountClanId) {
      return null;
    }
    return clanItems[currentAccountClanId];
  },
);
